module.exports = __webpack_public_path__ + "static/media/locationGrey.dc7c4798.svg";